import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d30e1660"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "room" }
const _hoisted_2 = { class: "room-items" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24px",
  height: "24px",
  viewBox: "0 0 128 128",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z",
      fill: "#262223"
    }),
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      from: "0 64 64",
      to: "360 64 64",
      dur: "600ms",
      repeatCount: "indefinite"
    })
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Rendering ")
const _hoisted_6 = { key: 1 }

import RoomItem from "@/components/room/RoomItem.vue"
  import RoomItemProps from "@/types/RoomItemProps"
  import CategoryDialog from "@/components/CategoryDialog.vue"
  import { computed, ref } from "vue"
  import categories from "@/types/Categories"
  import { useRouter } from "vue-router"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoomView',
  setup(__props) {

  const items = ref<Record<string, RoomItemProps | undefined>>(categories
    .reduce((acc: Record<string, RoomItemProps | undefined>, cat) => {
      acc[cat.key] = undefined
      return acc
    }, {}))

  const getCategory = (key: string) => categories.find(cat => cat.key === key)

  const currentCategory = ref<typeof categories[0]>()
  const dialogIsOpen = ref(false)

  const openCategory = (key: string) => {
    const category = categories.find((cat) => cat.key === key)

    if (!category) return

    currentCategory.value = category
    dialogIsOpen.value = true
  }

  const clearCategory = (key: string) => {
    items.value[key] = undefined
  }

  const handleItemSelected = (item: RoomItemProps) => {
    const key = currentCategory.value?.key
    if (!key) return

    items.value[key] = item
    dialogIsOpen.value = false
  }

  const router = useRouter()

  const isSubmitting = ref(false)
  const canSubmit = computed(() => Object.values(items.value).some(item => item !== undefined))

  const onSubmit = async () => {
    isSubmitting.value = true
    const tempItems = Object.entries(items.value)
      .filter(([, item]) => item !== undefined)
      .reduce((acc, [key, value]) => {
        acc[key] = [value?.slug]
        return acc
      }, {} as Record<string, Array<string | undefined>>)

    const response = await fetch('https://room-render.oliver.space/render', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ objects: tempItems }),
    })

    isSubmitting.value = false
    const data = await response.json()

    await router.push({ name: 'rendered', params: { url: data.url } })
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, key) => {
        return (_openBlock(), _createBlock(RoomItem, {
          key: key,
          category: getCategory(key),
          item: item,
          onClearCategory: ($event: any) => (clearCategory(key)),
          onOpenCategory: ($event: any) => (openCategory(key))
        }, null, 8, ["category", "item", "onClearCategory", "onOpenCategory"]))
      }), 128))
    ]),
    _createElementVNode("button", {
      disabled: !_unref(canSubmit),
      class: "submit-btn yellow",
      type: "submit",
      onClick: onSubmit
    }, [
      (isSubmitting.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _hoisted_5
          ], 64))
        : (_openBlock(), _createElementBlock("span", _hoisted_6, "Submit"))
    ], 8, _hoisted_3),
    _createVNode(CategoryDialog, {
      "is-open": dialogIsOpen.value,
      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((dialogIsOpen).value = $event)),
      "current-category": currentCategory.value,
      onItemSelected: handleItemSelected
    }, null, 8, ["is-open", "current-category"])
  ]))
}
}

})